<template>
  <div class="modal-edit-member">
    <div class="modal-head mb-2">
      <h4>ADD TEAM MEMBER</h4>
      <a href="javascript:;" class="close" @click="$emit('close')"></a>
    </div>

    <div class="modal-body">
      <div class="row">
        <div class="col-6">
          <div class="form-group">
            <label>FIRST NAME *</label>
            <input type="text" name="first_name" id="first_name" ref="inputName"
                   :class="{'form-control': true, 'is-invalid': errors.has('first_name')}"
                   v-validate.disable="{ required: true }"
                   v-model="postData.first_name">
            <div class="invalid-feedback">{{ errors.first('first_name') }}</div>
          </div>
        </div>
        <div class="col-6">
          <div class="form-group">
            <label>LAST NAME *</label>
            <input type="text" name="last_name" id="last_name"
                   :class="{'form-control': true, 'is-invalid': errors.has('last_name')}"
                   v-validate.disable="{ required: true }"
                   v-model="postData.last_name">
            <div class="invalid-feedback">{{ errors.first('last_name') }}</div>
          </div>
        </div>
      </div>
      <div class="form-group">
        <label>EMAIL ADDRESS *</label>
        <input type="email" name="email" id="email"
               :class="{'form-control': true, 'is-invalid': errors.has('email')}"
               v-validate.disable="{ required: true }"
               v-model="postData.email">
        <div class="invalid-feedback">{{ errors.first('email') }}</div>
      </div>
      <div class="form-group">
        <label>TEAM</label>
        <v-select v-model="postData.deparment_id" :options="allDepartments" class="ft-manager" :reduce="item => item.id"
                  label="name" :searchable="false" placeholder="---"></v-select>
      </div>
      <div class="row">
        <div class="col-6">
          <div class="form-group">
            <label>BILLABLE RATE</label>
            <input type="text" class="form-control" v-model="postData.billable_rate">
          </div>
        </div>
        <div class="col-6">
          <div class="form-group">
            <label>COST RATE</label>
            <input type="text" class="form-control" v-model="postData.cost_rate">
          </div>
        </div>
      </div>
      <div class="form-group">
        <label>Access Level</label>
        <v-select id="user_type_id" name="user_type_id" v-model="postData.user_type_id"
                  :class="{'form-control': true, 'is-invalid': errors.has('user_type_id')}"
                  :options="userTypes" class="ft-manager" :reduce="item => item.id"
                  label="title" :searchable="false"></v-select>
      </div>
      <div class="row">
        <div class="col-6">
          <div class="form-group">
            <label for="password">Password <span class="text-danger">*</span></label>
            <input type="password" name="password" id="password"
                   :class="{'form-control': true, 'is-invalid': errors.has('password')}"
                   v-validate.disable="{ required: true }"
                   v-model="postData.password">
            <div class="invalid-feedback">{{ errors.first('password') }}</div>
          </div>
        </div>
        <div class="col-6">
          <div class="form-group">
            <label for="password_confirmation">Retype Password <span class="text-danger">*</span></label>
            <input type="password" name="password_confirmation" id="password_confirmation"
                   :class="{'form-control': true, 'is-invalid': errors.has('password_confirmation')}"
                   v-validate.disable="{ required: true }"
                   v-model="postData.password_confirmation">
            <div class="invalid-feedback">{{ errors.first('password_confirmation') }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal-foot">
      <div class="btns btns-2">
        <beat-loader v-if="state == 'saving'"></beat-loader>
        <template v-else>
          <button type="button" class="btn btn-outline-black" @click="doSave(1)">Save + Send Invite</button>
          <button type="button" class="btn btn-outline-gray" @click="doSave(0)">Save</button>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import BeatLoader from 'vue-spinner/src/BeatLoader'

import ServiceUser from '@/services/user'
export default {
  components: {
    BeatLoader,
  },
  data () {
    return {
      state: '',
      postData: false,
    }
  },
  watch: {},
  computed: mapState({
    userTypes: state => state.option.options.user_types,
    allDepartments: state => state.option.departments
  }),
  mounted () {
    this.init();
  },
  methods: {
    init () {
      this.resetForm();
    },
    resetForm () {
      let self = this;
      self.postData = {
        first_name: '',
        last_name: '',
        user_type_id: 3, /* Staff */
        email: '',
        department_id: '',
        billable_rate: 0,
        cost_rate: 0,
        password: '',
        password_confirmation: '',
        send_welcome: true,
      };
    },
    doSave (sendInvite) {
      let self = this;
      if (self.state == 'saving') {
        return;
      }
      self.postData.send_welcome = sendInvite;
      self.$validator.validateAll()
        .then(ok => {
          if ( ok ) {
            self.state = 'saving';
            ServiceUser.create(self.postData, user => {
              self.state = '';
              self.$notify({
                type: 'success',
                text: 'New user added successfully.'
              });
              self.resetForm();
              self.$parent.$emit('member-added', user);
              self.$emit('close');
            }, () => {
              self.state = '';
            });
          }
        });
    }
  }
}
</script>
